import SimpleLightbox from "simplelightbox"
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay } from 'swiper/modules'
import VMasker from 'vanilla-masker'

import '../../../../../scss/profile.scss'


document.addEventListener("DOMContentLoaded", function() {
    
    function getCookie(name) {
        return document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))?.split('=')[1];
    }
    
    document.querySelectorAll('.swiper').forEach(function(el) {
        new Swiper(el, {
            // configure Swiper to use modules
            modules: [Navigation, Pagination, Autoplay],
            direction: 'horizontal',
            loop: true,
    
            autoplay: {
                delay: 7000,
            },
    
            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
    
            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function () {
                    this.el.classList.add('swiper-finished');
                },
                slideChangeTransitionEnd: function () {
                    this.el.classList.add('swiper-finished');
                },
                slideChangeTransitionStart: function () {
                    this.el.classList.remove('swiper-finished');
                }
            }
    
        });
    })

    const zoomables = document.querySelectorAll('img.zoomable')
    for (const zoom of zoomables) {
        new_zoom = zoom.cloneNode(true)
        a = document.createElement('a')
        a.setAttribute('href', zoom.src)
        a.classList.add('fresco')
        a.appendChild(new_zoom)
        zoom.replaceWith(a);
    }
    
    new SimpleLightbox('a.fresco, .newsImageContainer a', {
        fileExt:false
    })

    const searchFilter = document.getElementById('search-filter-toggle')
    if (searchFilter) {
        searchFilter.textContent = "Filtrar"
        searchFilter.addEventListener('click', function(e) {
            e.preventDefault();
            // $('.actionMenuContent').toggle('fast')
        })
    }

    const masks = document.querySelectorAll('[data-mask]')
    for(const input of masks) {
        const mask = input.dataset.mask
        VMasker(input).maskPattern(mask);
    }

    function is_touch_enabled() {
        return ( 'ontouchstart' in window ) || 
               ( navigator.maxTouchPoints > 0 ) || 
               ( navigator.msMaxTouchPoints > 0 );
    }
    
    function mobileMenu() {
        const menu = document.getElementById('menu')
        if (menu) {
            const position = getComputedStyle(menu).position
            if(position === 'fixed' || is_touch_enabled()) {
                const items = document.querySelectorAll('#menu li a')
                items.forEach(function(elm) {
                    elm.addEventListener('click', function(e) {
                        e.preventDefault()
                        var link = this
                        var submenu = link.parentNode.querySelector('ul')
                        var opener = link.parentNode.querySelector('.opener')
                        
                        if (!submenu) {
                            window.location = link.getAttribute('href')
                        }
                        // link.closest('ul').querySelectorAll(`li .opener:not(#${opener.getAttribute('id')})`).forEach(function(checkbox) {
                        //     checkbox.removeAttribute('checked')
                        // })
                        if (opener.getAttribute('checked') !== null) {
                            window.location = link.getAttribute('href')
                        } else {
                            opener.setAttribute('checked', true)
                        }
    
                    })
                })
                // $('#menu li a').click(function(e){
                // })
            } else {
                // $('#menu li a').unbind('click').click()
            }
        }
    }

    function logout() {
        var logoutBtn = document.getElementById('personaltools-logout')
        if (!logoutBtn) return 
        
        logoutBtn.addEventListener('click', function(e) {
            e.preventDefault()
            
            var url = this.getAttribute('href')
            var cookie = getCookie('__lt')
        
            if (cookie === 'govbr') {
                url = url.replace('cas_', '')
                var logout_url = "https://sso.acesso.gov.br/logout?post_logout_redirect_uri=" + url
                var form = document.createElement("form");
                form.setAttribute("method", "post");
                form.setAttribute("action", logout_url);
                document.body.appendChild(form);
                form.submit();
            }

            window.location.href = url
        })
    }

    mobileMenu()
    logout()
    window.addEventListener('resize', function() {
        mobileMenu()
    }) 
});